import { render } from "./C2022E3.vue?vue&type=template&id=4060c6f5&ts=true"
import script from "./C2022E3.vue?vue&type=script&lang=ts"
export * from "./C2022E3.vue?vue&type=script&lang=ts"

import "./C2022E3.vue?vue&type=style&index=0&id=4060c6f5&lang=less"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__